import { defaultTo } from 'ramda'
import { combineReducers } from 'redux'

import { FunnelOrder } from '../../data/models/funnelOrder'
import { themeCitiesReducer } from './themeCities/reducer'

export const funnelOrderReducer = combineReducers<FunnelOrder>({
  themeCities: themeCitiesReducer,
  destination: defaultTo(null),
  excludedCities: defaultTo(null),
  excludedCitiesIds: defaultTo(null),
  includedCitiesIds: defaultTo(null),
  driveDestination: defaultTo(null),
  departureDate: defaultTo(null),
  year: defaultTo(null),
  month: defaultTo(null),
  theme: defaultTo(null),
  entry: defaultTo(null),
  days: defaultTo(null),
  nights: defaultTo(null),
  locations: defaultTo(null),
  numberOfAdults: defaultTo(null),
  numberOfChildren: defaultTo(null),
  numberOfBabies: defaultTo(null),
  numberOfPets: defaultTo(null),
  airports: defaultTo(null),
  outgoingTime: defaultTo(null),
  incomingTime: defaultTo(null),
  roomType: defaultTo(null),
  pp: defaultTo(null),

  includeBreakfast: defaultTo(null),
  trainTicket: defaultTo(null),
  trainTicket12: defaultTo(null),
  extraLuggage: defaultTo(null),
  numberOfBags: defaultTo(null),
  travelInsurance: defaultTo(null),
  cancellationInsurance: defaultTo(null),
  privateRoom: defaultTo(null),
  arrangeTransfer: defaultTo(null),
  babyCrib: defaultTo(null),
  co2Compensation: defaultTo(null),
  flexibleRebooking: defaultTo(null),
  bedAndBreakfast: defaultTo(null),

  travelers: defaultTo(null),
  babies: defaultTo(null),

  note: defaultTo(null),
  giftcards: defaultTo(null),

  total: defaultTo(null),
  useWallet: defaultTo(null),
  wallet: defaultTo(null),
  originalTotal: defaultTo(null),

  paymentToken: defaultTo(null),
  orderId: defaultTo(null),
  paymentAmount: defaultTo(null),
  crossSellPrices: defaultTo(null),

  discountCode: defaultTo(null),
  totmOrder: defaultTo(null),
})
